const API_BASE_URL = "https://ofm.stran.store/api/facilis-to-hubspot";
//const API_BASE_URL = "http://localhost:4000/api/facilis-to-hubspot";


export async function fetchJobLookup(jobId){
  const response = await fetch(`${API_BASE_URL}/sync/${jobId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || "Job lookup failed");
  }

  return response.json();
}